import React, { useContext, useState } from 'react';
import { Container, Grid, Modal, Embed } from 'semantic-ui-react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { LargeMonitorContext } from '../context';
import InlineSvg from './InlineSvg';
import { toSnakeCase } from '../helpers/common';

const Testimonial = (props) => {
  const { module } = props;
  const { anchorTagLinkText, testimonial, variations } = module;
  const { quote, author } = testimonial;
  const { branding, testimonialType, video, image } = variations;
  const colNum =
    testimonialType === 'video' || testimonialType === 'image' ? 2 : 1;
  const hasBrand = branding !== 'unbranded' ? true : false;
  let detailBranding = branding === 'unbranded' ? 'citipower' : branding;

  const [hovered, setHovered] = useState(false);
  const toggleHover = () => setHovered(!hovered);

  const videoTrigger = video?.thumbnail?.localFile?.childImageSharp ? (
    <div className="testimonial__video-poster">
      <GatsbyImage
        image={video.thumbnail.localFile.childImageSharp.gatsbyImageData}
        className="testimonial__video-thumb"
        alt={video.thumbnail.alt_text || ''}
      />
      <div
        className={`testimonial__video-thumb-icon testimonial--brand-${branding}__video-thumb-icon${
          hovered ? ' hover' : ''
        }`}
        onMouseEnter={toggleHover}
        onMouseLeave={toggleHover}
      >
        {hovered ? (
          <InlineSvg
            className="testimonial__video-thumb-play"
            name="play-arrow"
            color="white"
          />
        ) : (
          <InlineSvg
            className="testimonial__video-thumb-play"
            name="play-arrow"
            color={`brand-${detailBranding}`}
          />
        )}
      </div>
    </div>
  ) : null;

  const largeMonitorContext = useContext(LargeMonitorContext);

  return (
    <section
      className={`testimonial testimonial--brand-${branding}${
        hasBrand === true ? ' has-brand' : ''
      }`}
      id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}
    >
      <Container>
        <Grid>
          <Grid.Row className="testimonial__row">
            {largeMonitorContext && <Grid.Column width={1}></Grid.Column>}
            {testimonialType && (
              <Grid.Column width={largeMonitorContext ? 10 : 12}>
                <div className="testimonial__quote-container">
                  {
                    // make two layout variations depending on the colNum

                    colNum === 2 ? (
                      <>
                        <div className="testimonial__quote-content--twocol">
                          <div className="testimonial__quote-text_container">
                            <p className="testimonial__quote">
                              {quote && quote}
                            </p>
                            {author ? (
                              <p className="testimonial__author">
                                &mdash; {author}
                              </p>
                            ) : null}
                          </div>
                          <div className="">
                            {testimonialType === 'video' &&
                              video &&
                              video.youtubeId && (
                                <Modal
                                  className="testimonial__video-modal"
                                  trigger={videoTrigger}
                                  closeIcon
                                >
                                  <Modal.Content className="testimonial__video-content">
                                    <Embed
                                      active
                                      id={video.youtubeId}
                                      source="youtube"
                                    />
                                  </Modal.Content>
                                </Modal>
                              )}
                            {testimonialType === 'image' &&
                              image &&
                              image.localFile &&
                              image.localFile.childImageSharp && (
                                <GatsbyImage
                                  image={
                                    image.localFile.childImageSharp
                                      .gatsbyImageData
                                  }
                                  className="testimonial__image"
                                  alt={image.alt_text || ''}
                                />
                              )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="testimonial__quote-content--fullwidth">
                        <p className="testimonial__quote">{quote && quote}</p>
                        {author ? (
                          <p className="testimonial__author">
                            &mdash; {author}
                          </p>
                        ) : null}
                      </div>
                    )
                  }
                </div>
              </Grid.Column>
            )}
            {largeMonitorContext && <Grid.Column width={1}></Grid.Column>}
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default Testimonial;
